import { render, staticRenderFns } from "./Auftrag.vue?vue&type=template&id=e679dbb4"
import script from "./Auftrag.vue?vue&type=script&lang=js"
export * from "./Auftrag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports